<template>
  <button @click="onClickFacebook">
    <span class="icon icon-facebook"></span>
  </button>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    fullUrl () {
      return window.location.origin + this.$route.fullPath
    }
  },
  methods: {
    onClickFacebook () {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.fullUrl}`, 'pop', 'width=600, height=400, scrollbars=no')
    }
  }
}
</script>
